import { cajaService } from '../../services/api';
import { descargarBlob } from '../../utils/descargar';
import { btnSecundario } from '../../components/ui/estilos';
import { delta, usePeriodo } from './periodo';
import { Encabezado, Kpis, Tabla, Tarjeta } from './ui';
import { num, useReporte } from './useReporte';

// Semáforo de cocina: ≤15 min excelente, 16–25 aceptable, más es cuello de botella.
const color = (min: number) => min <= 15 ? 'var(--ok)' : min <= 25 ? 'var(--warn)' : 'var(--danger)';
const minutos = (v: any) => v == null ? '—' : `${Math.round(num(v))} min`;

export default function Tiempos() {
  const p = usePeriodo('hoy');
  const { datos, error } = useReporte(cajaService.getTiempos, p.actual, p.previo);
  const t = datos?.actual as any, prev = (datos?.previo as any)?.promedios;
  const pr = t?.promedios;
  const porHora: any[] = t?.por_hora || [];
  const maxHora = Math.max(1, ...porHora.map(h => num(h.avg_min)));
  const [ini, fin] = p.actual;

  const exportar = () => {
    const filas = [
      ['REPORTE DE TIEMPOS DE ATENCIÓN'], [`Periodo: ${ini} al ${fin}`], [],
      ['Comandas analizadas', pr.total_comandas],
      ['Pedido → cocina inicia (min)', pr.avg_min_pedido_a_cocina],
      ['Preparación en cocina (min)', pr.avg_min_preparacion],
      ['Tiempo total promedio (min)', pr.avg_min_total],
      ['Rango (min)', `${pr.min_total}–${pr.max_total}`], [],
      ['Hora', 'Comandas', 'Tiempo promedio (min)'],
      ...porHora.map(h => [`${String(h.hora).padStart(2, '0')}:00`, h.comandas, h.avg_min]),
    ];
    descargarBlob(new Blob(['﻿' + filas.map(r => r.join('\t')).join('\n')], { type: 'text/tab-separated-values;charset=utf-8' }), `tiempos-${ini}-${fin}.xls`);
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
      <Encabezado titulo="Tiempos de cocina" p={p}
        extra={pr?.total_comandas > 0 && <button onClick={exportar} style={{ ...btnSecundario, height: 38, fontSize: 14, padding: '0 12px' }}>Exportar Excel</button>} />
      {error && <div role="alert" style={{ color: 'var(--danger)', fontWeight: 700 }}>{error}</div>}
      {!datos && !error && <div style={{ color: 'var(--muted)' }}>Cargando…</div>}
      {pr && !pr.total_comandas && <Tarjeta titulo="Sin datos"><div style={{ color: 'var(--muted)' }}>Sin comandas terminadas en este periodo.</div></Tarjeta>}
      {pr?.total_comandas > 0 && <>
        <Kpis items={[
          // Aquí bajar es bueno: delta invertido.
          { label: 'Total promedio', valor: minutos(pr.avg_min_total), delta: delta(num(pr.avg_min_total), num(prev?.avg_min_total), p.periodo, true) },
          { label: 'Del pedido a cocina', valor: minutos(pr.avg_min_pedido_a_cocina), delta: { texto: 'Espera antes de empezar', color: 'var(--muted)' } },
          { label: 'Preparación', valor: minutos(pr.avg_min_preparacion), delta: { texto: 'De empezar a listo', color: 'var(--muted)' } },
          { label: 'Comandas', valor: String(pr.total_comandas), delta: { texto: `Rango ${pr.min_total ?? '—'}–${pr.max_total ?? '—'} min`, color: 'var(--muted)' } },
        ]} />
        <Tarjeta titulo="Tiempo promedio por hora" extra={<span style={{ fontSize: 13, color: 'var(--muted)' }}>≤15 excelente · 16–25 aceptable · +25 lento</span>}>
          <Tabla columnas={[{ t: 'HORA', w: '120px' }, { t: 'COMANDAS', w: '90px', der: true }, { t: 'PROMEDIO', w: '90px', der: true }, { t: '', w: 'minmax(80px,1fr)' }]}
            filas={porHora.map(h => [
              `${String(h.hora).padStart(2, '0')}:00`, h.comandas,
              <b style={{ color: color(num(h.avg_min)) }}>{minutos(h.avg_min)}</b>,
              <span style={{ display: 'block', height: 8, borderRadius: 999, background: 'var(--well)' }}>
                <span style={{ display: 'block', height: '100%', borderRadius: 999, width: `${num(h.avg_min) / maxHora * 100}%`, background: color(num(h.avg_min)) }} />
              </span>,
            ])} />
        </Tarjeta>
      </>}
    </div>
  );
}
